var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user_prof d-flex flex-column" }, [
    _c("div", { staticClass: "mb-3" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-outline-success btn-lg btn-block waves-effect waves-themed",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.go_profile.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n                PROFILE\n            ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-outline-danger btn-lg btn-block waves-effect waves-themed",
          attrs: { type: "submit" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.logout.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n\t\t\t\tEXIT\n\t\t\t")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }